import { Button, Input, SelectGeneric, Switch } from 'ypf-pas-general-ui-components';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { workReportLineStatus } from '../../../../utils/dataStatus';
import { certificationServiceStatus } from '../../../../constants/constants';
import { SelectGenericOptions, Line } from '../../../../utils/globalPropTypes';
import useProgramPoint from '../useProgramPoint';

const ProgramPointRow = ({
  dailyView,
  disabledButton,
  disabledInputPP,
  disabledInputQuantity,
  displayButtons,
  expertReview,
  editCSA,
  handleClickRectifyButton,
  index,
  isInspector,
  line,
  onChangeExpertReview,
  programPoint,
  setInputBackgroundColor,
  showExpertReview,
  showRectifyQuantityButton,
  values,
  viewCSA,
  viewInputs,
  idParteDiario,
  setFieldValue,
  tipoAsignacion,
  eventoSigla,
  formName
}) => {
  const {
    handleSuprPP,
    handleAddPP,
    handleChangePoints,
    handleChangeQuantity,
    handleChangeCode,
    handleChangeSubCode,
    handleChangeCost,
    handleChangeClasification,
    costOptions
  } = useProgramPoint({
    values,
    setFieldValue,
    notificaPorCSA: line?.notificaPorCSA,
    tipoAsignacion,
    idParteDiario,
    evento: values?.eventoSigla || eventoSigla,
    indexPP: index,
    formName
  });

  const hasDisabledAddPP = () =>
    values?.programPoints?.find((qntyObj) => !qntyObj.quantity || !qntyObj.points) ||
    disabledButton;

  const getTotalProgramPoints = () => values?.programPoints?.length || 0;

  const disabledAddPP = hasDisabledAddPP();

  const isLineFixedStatus = line?.estadoEnum === workReportLineStatus.fijar;

  const totalProgramPoints = getTotalProgramPoints();
  const isLastProgramPoint = totalProgramPoints > 0 && index === totalProgramPoints - 1;

  const disabledEditPP = false;

  const getMarginLeft = () => {
    if (displayButtons) return '0px';
    if (isLineFixedStatus && dailyView) return '';

    return '50px';
  };

  return (
    <div className="input-row" key={`programPoint-${index.toString()}`}>
      <Row className="input-container g-3">
        <Col className="d-flex" sm={2}>
          <Input
            backgroundColor={
              disabledInputQuantity && isInspector
                ? setInputBackgroundColor({
                    dailyWorkReport: line
                  })
                : ''
            }
            border={`${!values.habilitaVentana ? 'border border-danger' : 'default'}`}
            className="w-100 style-input-modal"
            disabled={disabledInputQuantity || !values.habilitaVentana}
            name="quantity"
            onChange={(val) => handleChangeQuantity(val, index)}
            placeholder="--"
            type="number"
            value={programPoint?.quantity}
          />
        </Col>
        <Col className="compact-input p-1" sm={1}>
          <Input
            border={`${!values.habilitaVentana ? 'border border-danger' : 'default'}`}
            className="style-input-modal gap-2"
            disabled={disabledInputPP || disabledEditPP || !values.habilitaVentana}
            name="points"
            onChange={(val) => handleChangePoints(val, index)}
            placeholder="--"
            type="number"
            value={programPoint?.points}
          />
        </Col>
        {displayButtons && (
          <Col className="d-flex justify-content-start align-items-center" sm={1}>
            <div className="d-flex">
              <Button
                colorIcon="danger"
                disabled={values?.programPoints?.length === 1 || disabledButton}
                icon={AiOutlineMinusCircle}
                onClick={() => handleSuprPP(index)}
                sizeIcon="24px"
                type="button"
                variant="light-gray"
                widthButton="40px"
              />
              <Button
                colorIcon="primary"
                disabled={disabledAddPP}
                icon={AiOutlinePlusCircle}
                onClick={() => handleAddPP()}
                sizeIcon="24px"
                type="button"
                variant="light-gray"
                widthButton="40px"
              />
            </div>
          </Col>
        )}
        {viewCSA && (
          <>
            <Col
              sm={2}
              style={{
                marginLeft: getMarginLeft(),
                marginBottom: viewInputs ? '0px' : '-18px'
              }}
            >
              {viewInputs ? (
                <Input
                  className="w-auto"
                  disabled
                  value={
                    values?.programPoints[index]?.cost?.label || values?.programPoints[index]?.cost
                  }
                />
              ) : (
                <SelectGeneric
                  className="w-auto"
                  isDisabled={!editCSA || !values.habilitaVentana}
                  menuPosition="fixed"
                  name="cost"
                  onChange={(e) => handleChangeCost(e, index)}
                  optionMapper={{
                    value: 'id',
                    label: 'nombre'
                  }}
                  options={costOptions}
                  paddingIndicator={4}
                  placeholder="-- "
                  value={values?.programPoints[index]?.cost}
                  withSelect="100%"
                />
              )}
            </Col>

            <Col
              sm={1}
              style={{
                padding: '0.5px',
                marginLeft: '10px',
                marginBottom: viewInputs ? '0px' : '-18px',
                width: '120px'
              }}
            >
              {viewInputs ? (
                <Input
                  className="w-auto"
                  disabled
                  value={
                    values?.programPoints[index]?.clasification?.label ||
                    values?.programPoints[index]?.clasification
                  }
                />
              ) : (
                <SelectGeneric
                  defaultValueOneOption
                  isDisabled={!editCSA || !values.habilitaVentana}
                  menuPosition="fixed"
                  name="clasification"
                  onChange={(e) => handleChangeClasification(e, index)}
                  optionMapper={{
                    value: 'id',
                    label: 'nombre'
                  }}
                  options={values?.programPoints[index]?.optionsClasification}
                  paddingIndicator={4}
                  placeholder="-- "
                  value={values?.programPoints[index]?.clasification}
                  withSelect="100%"
                />
              )}
            </Col>

            <Col
              sm={1}
              style={{
                padding: '0.5px',
                marginLeft: '15px',
                // marginTop: '35px',
                marginBottom: viewInputs ? '0px' : '-18px',
                marginRight: '15px'
              }}
            >
              {viewInputs ? (
                <Input
                  className="w-auto"
                  disabled
                  value={
                    values?.programPoints[index]?.code?.label || values?.programPoints[index]?.code
                  }
                />
              ) : (
                <SelectGeneric
                  isDisabled={!editCSA || !values.habilitaVentana}
                  menuPosition="fixed"
                  name="code"
                  onChange={(e) => handleChangeCode(e, index)}
                  optionMapper={{
                    value: 'id',
                    label: 'nombre'
                  }}
                  options={values?.programPoints[index]?.optionsCode}
                  paddingIndicator={4}
                  placeholder="-- "
                  value={values?.programPoints[index]?.code}
                  withSelect="100%"
                />
              )}
            </Col>
            <Col
              sm={1}
              style={{
                padding: '0.5px',
                marginLeft: '0px',
                marginBottom: viewInputs ? '0px' : '-18px'
              }}
            >
              {viewInputs ? (
                <Input
                  className="w-auto"
                  disabled
                  value={
                    values?.programPoints[index]?.subCode?.label ||
                    values?.programPoints[index]?.subCode
                  }
                />
              ) : (
                <SelectGeneric
                  isDisabled={!editCSA || !values.habilitaVentana}
                  menuPosition="fixed"
                  name="subCode"
                  onChange={(e) => handleChangeSubCode(e, index)}
                  optionMapper={{
                    value: 'id',
                    label: 'nombre'
                  }}
                  options={values?.programPoints[index]?.optionsSubCode}
                  paddingIndicator={4}
                  placeholder="-- "
                  value={values?.programPoints[index]?.subCode}
                  withSelect="100%"
                />
              )}
            </Col>
            <Col
              className="overflow-hidden text-truncate text-nowrap"
              style={{
                padding: '0.5px',
                marginLeft: '40px',
                maxWidth: '500px'
              }}
            >
              <OverlayTrigger
                className=""
                delay={{
                  show: 250,
                  hide: 400
                }}
                overlay={
                  <Tooltip id="button-tooltip">
                    <span>{values?.programPoints[index]?.detail || '--'}</span>
                  </Tooltip>
                }
                placement="top"
              >
                <span>{values?.programPoints[index]?.detail || '--'}</span>
              </OverlayTrigger>
            </Col>
          </>
        )}

        {showRectifyQuantityButton && isLastProgramPoint && (
          <Col className="d-flex justify-content-start mt-2 px-2 py-2" sm={12}>
            <Button
              fontSizeLabel="14px"
              label={disabledInputQuantity ? 'Rectificar cantidad' : 'Cancelar'}
              onClick={handleClickRectifyButton}
              sizeIcon="17px"
              type="button"
              variant="outline-primary"
            />
          </Col>
        )}

        {line?.estadoRevision?.estadoCertEnum !== certificationServiceStatus.wrong &&
          isInspector &&
          showExpertReview &&
          showRectifyQuantityButton &&
          index === 0 && (
            <Col className="d-flex justify-content-between align-items-start col-sm-3 py-2" sm={3}>
              <div className="d-flex align-items-center">
                <h6 className="mx-2 my-0">Revisión experta</h6>
                <Switch
                  checked={expertReview}
                  falseLabel="NO"
                  name="expertReview"
                  onChange={onChangeExpertReview}
                  size="sm"
                  trueLabel="SÍ"
                />
              </div>
            </Col>
          )}
      </Row>
    </div>
  );
};

export default ProgramPointRow;

ProgramPointRow.propTypes = {
  dailyView: PropTypes.bool,
  disabledButton: PropTypes.bool,
  disabledInputPP: PropTypes.bool,
  disabledInputQuantity: PropTypes.bool,
  displayButtons: PropTypes.bool,
  editCSA: PropTypes.bool,
  expertReview: PropTypes.bool,
  setFieldValue: PropTypes.func,
  tipoAsignacion: PropTypes.number.isRequired,
  idParteDiario: PropTypes.number.isRequired,
  handleClickRectifyButton: PropTypes.func,
  index: PropTypes.number.isRequired,
  isInspector: PropTypes.bool,
  line: Line,
  onChangeExpertReview: PropTypes.func,
  programPoint: PropTypes.shape({
    id: PropTypes.number,
    quantity: PropTypes.string,
    quantityFijados: PropTypes.string,
    points: PropTypes.string,
    pointsFijados: PropTypes.string,
    code: PropTypes.oneOfType([PropTypes.shape({ label: PropTypes.string })]),
    subCode: PropTypes.oneOfType([PropTypes.shape({ label: PropTypes.string })]),
    cost: PropTypes.oneOfType([PropTypes.shape({ label: PropTypes.string })]),
    clasification: PropTypes.oneOfType([PropTypes.shape({ label: PropTypes.string })]),
    optionsCode: SelectGenericOptions,
    optionsSubCode: SelectGenericOptions,
    optionsClasification: SelectGenericOptions,
    detail: PropTypes.string
  }),
  setInputBackgroundColor: PropTypes.func.isRequired,
  showExpertReview: PropTypes.bool,
  showRectifyQuantityButton: PropTypes.bool,
  values: PropTypes.shape({
    programPoints: PropTypes.arrayOf(
      PropTypes.shape({
        quantity: PropTypes.number.isRequired,
        points: PropTypes.number.isRequired,
        id: PropTypes.number,
        fecha: PropTypes.string,
        label: PropTypes.string,
        code: SelectGenericOptions,
        cost: SelectGenericOptions,
        optionsCode: SelectGenericOptions,
        optionsSubCode: SelectGenericOptions,
        subCode: SelectGenericOptions,
        clasification: SelectGenericOptions,
        optionsClasification: SelectGenericOptions,
        optionsActivities: PropTypes.arrayOf(PropTypes.shape({})),
        activity: PropTypes.shape({}),
        detail: PropTypes.string
      })
    ),
    expertReview: PropTypes.bool,
    habilitaVentana: PropTypes.bool,
    eventoSigla: PropTypes.string
  }),
  viewCSA: PropTypes.bool,
  viewInputs: PropTypes.bool,
  eventoSigla: PropTypes.string.isRequired,
  formName: PropTypes.string
};
ProgramPointRow.defaultProps = {
  dailyView: false,
  disabledButton: false,
  disabledInputPP: false,
  disabledInputQuantity: false,
  displayButtons: false,
  editCSA: false,
  expertReview: false,
  setFieldValue: () => {},
  handleClickRectifyButton: () => {},
  isInspector: false,
  line: {
    positionName: '',
    lineName: '',
    idParteDiario: 0,
    estadoEnum: 0,
    tienePuntosPrograma: false,
    unidadMedida: ''
  },
  onChangeExpertReview: () => {},
  programPoint: {},
  showExpertReview: false,
  showRectifyQuantityButton: false,
  values: {
    programPoints: [],
    expertReview: false,
    habilitaVentana: true,
    eventoSigla: null
  },
  viewCSA: false,
  viewInputs: false,
  formName: ''
};
